import { api } from "@/lib/api";

import type { ActivityLog, ActivityLogList } from "@artisancode/api-types";

export interface ActivityLogListParams {
  q?: string;
  entityName?: string;
  entityId?: string;
  userId?: string;
  activity?: string;
  dateFrom?: string;
  dateTo?: string;
  workspace_id?: string;
  pagination?: { page?: number; per_page?: number };
}

export interface EntityActivityLogParams {
  pagination?: { page?: number; per_page?: number };
}

export const activityLogService = {
  list: (params?: ActivityLogListParams) => {
    const queryParams: Record<string, string | number | boolean | undefined> = {
      page: params?.pagination?.page,
      per_page: params?.pagination?.per_page,
      q: params?.q,
      entityName: params?.entityName,
      entityId: params?.entityId,
      userId: params?.userId,
      activity: params?.activity,
      dateFrom: params?.dateFrom,
      dateTo: params?.dateTo,
      workspace_id: params?.workspace_id,
    };
    return api.get<ActivityLogList>("/activity-logs", queryParams);
  },

  getByEntity: (
    entityName: string,
    entityId: string,
    params?: EntityActivityLogParams,
  ) => {
    const queryParams: Record<string, string | number | undefined> = {
      page: params?.pagination?.page,
      per_page: params?.pagination?.per_page,
    };
    return api.get<ActivityLogList>(
      `/activity-logs/entity/${entityName}/${entityId}`,
      queryParams,
    );
  },

  getById: (id: string) => api.get<ActivityLog>(`/activity-logs/${id}`),
};
